// Third party
import { persistStore } from 'redux-persist';
import { configureStore } from '@reduxjs/toolkit';

// Components
import profileDataSlice from './profile_data/slice';
import catalogDataSlice from './catalog_data/slice';
import shootingDataSlice from './shooting_data/slice';
import vcatKitsDataSlice from './vcat_kits_data/slice';
import dashboardDataSlice from './dashboard_data/slice';
import assignmentDataSlice from './assignment_data/slice';
import managedUsersDataSlice from './managed_users_data/slice';
import accountRootsDataSlice from './account_roots_data/slice';
import billingReportDataSlice from './billing_report_data/slice';
import scenarioUsageDataSlice from './scenario_usage_data/slice';
import activeSessionsDataSlice from './active_sessions_data/slice';

const store = configureStore({
  reducer: {
    profileDataSlice,
    catalogDataSlice,
    vcatKitsDataSlice,
    shootingDataSlice,
    dashboardDataSlice,
    assignmentDataSlice,
    managedUsersDataSlice,
    accountRootsDataSlice,
    billingReportDataSlice,
    scenarioUsageDataSlice,
    activeSessionsDataSlice,
  },
  middleware: (getDefaultMiddleware) => getDefaultMiddleware({
    serializableCheck: false,
  }),
});

const persistor = persistStore(store);

export type AppDispatch = typeof store.dispatch;
export type RootState = ReturnType<typeof store.getState>;
export {
  store,
  persistor,
};

export { catalogDataActions } from './catalog_data/slice';
export { profileDataActions } from './profile_data/slice';
export { shootingDataActions } from './shooting_data/slice';
export { vcatKitsDataActions } from './vcat_kits_data/slice';
export { dashboardDataActions } from './dashboard_data/slice';
export { assignmentDataActions } from './assignment_data/slice';
export { managedUsersDataActions } from './managed_users_data/slice';
export { accountRootsDataActions } from './account_roots_data/slice';
export { scenarioUsageDataActions } from './scenario_usage_data/slice';
export { billingReportDataActions } from './billing_report_data/slice';
export { activeSessionsDataActions } from './active_sessions_data/slice';

export {
  getSessionsData,
  getScenariosData,
  getRepetitionsData,
  getTransactionsData,
  getWeaponPresentation,
  getStabilityPresentation
} from './shooting_data/selectors';
export { getAssignment } from './assignment_data/selectors';
export { getVcatKitsData } from './vcat_kits_data/selectors';
export { getAccountRoots } from './account_roots_data/selectors';
export { getManagedUsersData } from './managed_users_data/selectors';
export { getActiveSessions } from './active_sessions_data/selectors';
export { getBillingReportData } from './billing_report_data/selectors';
export { getScenarioUsageData } from './scenario_usage_data/selectors';
export { getAuthInfo, getProfileInfo, getBiometricDataInfo } from './profile_data/selectors';
export { getCatalogItems, getCatalogWeapons, getCatalogItemsCollections, getCatalogNextTraining } from './catalog_data/selectors';
export { getWorstWeaponPresentation, getRankings, getScores, getTotalTrainTime } from './dashboard_data/selectors';
